'use strict';
var regexpExec = require('./_regexp-exec');
require('./_export')({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});



// WEBPACK FOOTER //
// ./~/@babel/polyfill/~/core-js/modules/es6.regexp.exec.js